
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.25 5h15.5l.25.594C24.585 6.92 25 8.67 25 11c0 4.616-3.516 8.431-8 8.938v6.063h5v2H10v-2h5v-6.063c-4.484-.506-8-4.322-8-8.938 0-2.325.413-4.077 1-5.406zm1.406 2C9.294 8.001 9 9.235 9 11c0 3.877 3.123 7 7 7a6.967 6.967 0 006.906-6H11v-2h11.938c-.081-1.241-.277-2.207-.563-3H9.656z"}})])
          )
        }
      }
    